<template>
  <div>
    <q-table
      dense
      :data="filtered"
      :columns="columns"
      :loading="loading"
    >
      <template v-slot:top-right>
        <q-input dense filled label="Filtrar" v-model="filterTxt" />
      </template>
      <template v-slot:body-cell-resultados="props">
        <q-td>
          <q-btn
            flat
            dense
            label="Ver"
            size="sm"
            color="primary"
            icon="open_in_new"
            @click="openRespostasUsuario(props.row)"
          />
        </q-td>
      </template>
    </q-table>
    <RespostasUsuario :idPesquisa="idPesquisa" :usuario="usuarioSelecionado" ref="respostasUsuario" />
  </div>
</template>

<script>
import { getRespondedores } from '../../services/pesquisa'
import RespostasUsuario from './RespostasUsuario'
import { formatCpfCnpj } from '../../filters/cpfCnpj'
export default {
  props: {
    idPesquisa: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      usuarioSelecionado: {},
      filterTxt: '',
      respondedores: [],
      columns: [
        { name: 'nome', field: 'nome', label: 'Nome', align: 'left' },
        { name: 'cpf', field: 'cpf', label: 'CPF', align: 'left', format: value => formatCpfCnpj(value) },
        { name: 'email', field: 'email', label: 'Email', align: 'left' },
        { name: 'resultados', field: 'resultados', label: 'Resultados', align: 'left' }
      ]
    }
  },

  mounted () {
    this.getRespondedores()
  },

  methods: {
    async getRespondedores () {
      try {
        this.loading = true
        this.respondedores = await getRespondedores({ idPesquisa: this.idPesquisa })
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível buscar os usuários no momento. Tente daqui a pouco.'
        })
      } finally {
        this.loading = false
      }
    },

    openRespostasUsuario (usuario) {
      this.usuarioSelecionado = usuario
      setTimeout(() => {
        this.$refs.respostasUsuario.open()
      }, 50)
    }
  },

  computed: {
    filtered () {
      if (!this.filterTxt) return this.respondedores
      return this
        .respondedores
        .filter(x => {
          return (x.nome.toLowerCase().includes(this.filterTxt)) || (x.cpf.toLowerCase().includes(this.filterTxt)) || (x.email.toLowerCase().includes(this.filterTxt))
        })
    }
  },

  components: {
    RespostasUsuario
  }
}
</script>